import { apiUrl } from '../../../constants/global';
import fetchAPI from '../../../utils/fetchAPI';
import { TGetAdsClient } from 'types/Listings';

const MAX_ITEMS_TO_FETCH = 20;

const getListings = async (ids: string[]): Promise<TGetAdsClient> => {
  try {
    const itemIds = ids.slice(0, MAX_ITEMS_TO_FETCH).join(',');

    return await fetchAPI({
      url: `${apiUrl}items?ids=${itemIds}`,
    });
  } catch {
    return [];
  }
};

export default getListings;
